"use client";

// Eine Adresse in die Zwischenablage — mit Quittung.
import { Copy } from "lucide-react";
import { toast } from "@/components/ui/toast";

export function AdresseKopieren({ adresse }: { adresse: string }) {
  return (
    <button
      type="button"
      onClick={async () => {
        try {
          await navigator.clipboard.writeText(adresse);
          toast.success("Adresse kopiert", { description: adresse });
        } catch {
          toast.error("Kopieren ging nicht — bitte von Hand markieren.");
        }
      }}
      aria-label={`${adresse} kopieren`}
      title="Kopieren"
      className="text-text-tertiary hover:bg-bg-tertiary hover:text-text-primary grid h-8 w-8 shrink-0 place-items-center rounded-md transition-colors"
    >
      <Copy className="h-3.5 w-3.5" aria-hidden />
    </button>
  );
}
